import { render, staticRenderFns } from "./ReservationList.vue?vue&type=template&id=16afd6b1&lang=pug"
import script from "./ReservationList.vue?vue&type=script&lang=ts"
export * from "./ReservationList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports